import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

type StarStatusButtonProps = {
    status: 'ACTIVE' | 'INACTIVE'
}

export const StarStatusButton = (props: StarStatusButtonProps) => {
    const { t } = useTranslation()
    const t_MANAGE_WEB = `MANAGE_WEB`
    const [isColor, setIsColor] = useState<'#37B922' | 'red'>('#37B922')

    const onRenderStatus = () => {
        if (props.status === 'ACTIVE') {
            setIsColor('#37B922')
        } else {
            setIsColor('red')
        }
    }

    useEffect(() => {
        onRenderStatus()
    }, [props.status])

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', width: 'fit-content' }}>
            <Box sx={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: isColor }} />
            <Box sx={{ marginLeft: '8px', height: '100%', whiteSpace: ' nowrap' }}>
                {t(`${t_MANAGE_WEB}.STATUS_${props.status}`)}
            </Box>
        </Box>
    )
}